import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MUISwitch from '@material-ui/core/Switch';
import FormHelperText from '@material-ui/core/FormHelperText';

function Switch({ name, label, required, ...rest }) {
  const { fieldName, registerField, error, clearError } = useField(name);

  const inputRef = useRef({ checked: false });

  const [checked, setChecked] = useState(false);

  const handleChange = useCallback(
    event => {
      setChecked(event.target.checked);

      if (error) clearError();
    },
    [error, clearError]
  );

  useEffect(() => {
    inputRef.current.handleChange = handleChange;

    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'checked',
    });
  }, [fieldName, handleChange, registerField]);

  return (
    <FormControl
      component="fieldset"
      error={!!error}
      style={{ maxWidth: '200px' }}
    >
      <FormControlLabel
        label={
          <p>
            {label} {required && <b style={{ color: '#d50000' }}>*</b>}
          </p>
        }
        control={
          <MUISwitch
            inputRef={inputRef}
            checked={checked}
            onChange={handleChange}
            color="primary"
          />
        }
        labelPlacement="start"
        {...rest}
      />
      <FormHelperText>{error || ' '}</FormHelperText>
    </FormControl>
  );
}

export default Switch;

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

Switch.defaultProps = {
  required: false,
};
